import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SuperHttpClientProvider } from '@app/core/http';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public usuario: any = null;
  private roleIdSubject = new BehaviorSubject<number | null>(null);
  roleId$ = this.roleIdSubject.asObservable();

  constructor(private $shttp: SuperHttpClientProvider) {}

  private extractRoleId(user: any): number | null {
    if (!user) return null;
    const direct = user.idRol ?? user.rolId ?? user.roleId ?? user.rol?.idRol ?? user.role?.idRol;
    if (typeof direct === 'number') return direct;

    const roleName = Array.isArray(user.rolUserList)
      ? user.rolUserList[0]
      : user.rolUserList || user.roleName || user.role;
    if (roleName === 'Admin') return 1;
    if (roleName === 'Support') return 2;
    if (roleName === 'Basic') return 3;

    return null;
  }

  setUser(user: any): void {
    this.usuario = user;
    const roleId = this.extractRoleId(user);
    if (roleId !== null) {
      this.roleIdSubject.next(roleId);
    }
  }

  getRoleId(): number | null {
    return this.roleIdSubject.value;
  }

  getUserInfo() {
    return this.$shttp.default.get('/user/me').pipe(
      tap((user: any) => this.setUser(user))
    );
  }
}
